import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classname';
import Dropdown from 'components/Dropdown';
import Dropdownbody, {
  stylesForDropDown,
} from 'components/Dropdown/dropdownbody';
import { UpChevron, DownChevron } from 'assets/svgs';
import { globalStyles } from 'styles';
import styles from './status.module.scss';

const Status = (props) => {
  const statuses = Array.isArray(props.status) ? props.status : [];
  const altStatuses = Array.isArray(props.altStatuses) ? props.altStatuses : [];
  const [selected, setSelected] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState('');

  useEffect(() => {
    if (props.active) {
      setSelected(props.active);
    } else {
      if (props.status) {
        setSelected(props.status[0]);
      }
      if (props.altStatuses) {
        setSelected(props.altStatuses[0]);
      }
    }
    if (props.selectActive) {
      setActive(props.selectActive);
    }
  }, []);

  const handleSelect = (item, type) => {
    props.handleClick(item);
    setActive('');
    if (type === 'drop') {
      setSelected(item);
      setIsOpen(!isOpen);
      setActive(item);
    }
    if (type === 'pick') {
      setSelected(item);
      setActive(item);
    }
  };

  return (
    <div className={cx(globalStyles.flex)} data-testid="status">
      {props.firstItem ? (
        <div className={active === '' ? styles.allFilter : styles.allInactive}>
          <p onClick={() => handleSelect(props.firstItem)}>{props.firstItem}</p>
        </div>
      ) : null}

      {altStatuses && altStatuses.length !== 0 && (
        <div className={cx(styles.select, styles.altSelectBorder)}>
          {altStatuses.map((item, index) => (
            <div
              className={
                active !== item ? styles.selectAltDef : styles.selectAltBlue
              }
              key={index}
            >
              <button
                style={{ width: '100%' }}
                onClick={() => handleSelect(item, 'pick')}
                type="button"
              >
                {item}
              </button>
              {index !== altStatuses.length - 1 && (
                <span className={styles.selectAltBorder} />
              )}
            </div>
          ))}
        </div>
      )}

      {statuses && statuses.length !== 0 && (
        <>
          <Dropdown
            header={
              <div className={styles.select}>
                <label htmlFor={props.name} />
                <div
                  className={cx(
                    active === '' ? styles.selectDef : styles.selectBlue,
                    isOpen ? styles.selectButtonOpen : '',
                  )}
                  onClick={() => setIsOpen(!isOpen)}
                >
                  {Object.keys(selected).length === 0 ? (
                    <p className={styles.selectButtonDefault}>Select</p>
                  ) : (
                    <p
                      className={cx(
                        styles.selectButtonSelected,
                        styles.selectText,
                      )}
                    >
                      {selected}
                    </p>
                  )}
                  <div>
                    <span className={styles.selectBorder}>
                      {' '}
                      <span className={styles.selectArrow}>
                        {isOpen ? <UpChevron /> : <DownChevron />}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            }
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          >
            <Dropdownbody>
              {props.status.map((item, i) => (
                // eslint-disable-next-line jsx-a11y/no-redundant-roles
                <button
                  className={stylesForDropDown.dropdownitem}
                  style={{ width: '100%' }}
                  onClick={() => handleSelect(item, 'drop')}
                  key={i}
                >
                  <p className={stylesForDropDown.dropdownitemtext}>{item}</p>
                </button>
              ))}
            </Dropdownbody>
          </Dropdown>
        </>
      )}
    </div>
  );
};

Status.propTypes = {
  status: PropTypes.array,
  handleClick: PropTypes.func.isRequired,
  active: PropTypes.string.isRequired,
  firstItem: PropTypes.string.isRequired,
  altStatuses: PropTypes.array,
};

export default Status;
